import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { NoAuthGuard } from "./core/guard/no-auth.guard";
import { PublicGuard } from "./core/guard/public.guard";
import { RoleGuard } from "./core/guard/role.guard";
import { USER_COMPLETE_REGISTRATION_PROVIDER } from "./data/service/user-complete-registration/user-complete-registration.provider";
import { ChangePasswordAfterLoginComponent } from "./shared/component/change-password-after-login/change-password-after-login.component";

const routes: Routes = [
    {
        path: "",
        redirectTo: "courses-catalog",
        pathMatch: "full"
    },
    {
        path: "null",
        redirectTo: "courses-catalog",
        pathMatch: "full"
    },
    {
        path: "undfined",
        redirectTo: "courses-catalog",
        pathMatch: "full"
    },
    {
        path: "public",
        canActivate: [PublicGuard],
        loadChildren: () => import("./modules/public/public.module").then((m) => m.PublicModule)
    },
    {
        path: "certificates",
        canActivate: [RoleGuard],
        data: {
            expectedRole: "Customer"
        },
        loadChildren: () => import("./modules/certificates/certificates.module").then((m) => m.CertificatesModule)
    },
    {
        path: "new-payment",
        loadChildren: () => import("./modules/new-payment/new-payment-v2.module").then((m) => m.NewPaymentV2Module)
    },
    {
        path: "new-payment-v1",
        loadChildren: () => import("./modules/new-payment/new-payment.module").then((m) => m.NewPaymentModule)
    },
    // Redirecionar qualquer rota antiga de v2 para o novo padrão
    {
        path: "new-payment-v2/:productId/plans/:planId",
        redirectTo: "new-payment/:productId/plans/:planId",
        pathMatch: "full"
    },
    {
        path: "new-payment-v2/:productId/:planId",
        redirectTo: "new-payment/:productId/:planId",
        pathMatch: "full"
    },
    {
        path: "new-payment-v2/:productId",
        redirectTo: "new-payment/:productId",
        pathMatch: "full"
    },
    {
        path: "new-payment-v2",
        redirectTo: "new-payment",
        pathMatch: "full"
    },
    {
        path: "auth",
        canActivate: [NoAuthGuard],
        loadChildren: () => import("./modules/auth/auth.module").then((m) => m.AuthModule)
    },
    {
        path: "registrar",
        canActivate: [NoAuthGuard],
        loadChildren: () => import("./modules/registrar/registrar.module").then((m) => m.RegistrarModule)
    },
    {
        path: "complete-registration",
        canActivate: [RoleGuard],
        loadChildren: () =>
            import("./modules/complete-registration/complete-registration.module").then(
                (m) => m.CompleteRegistrationModule
            )
    },
    {
        path: "home",
        canActivate: [RoleGuard],
        data: {
            expectedRole: "Customer"
        },
        loadChildren: () => import("./modules/home/home.module").then((m) => m.HomeModule)
    },
    {
        path: "cursos",
        canActivate: [RoleGuard],
        data: {
            expectedRole: "Customer"
        },
        loadChildren: () => import("./modules/courses/courses.module").then((m) => m.CoursesModule)
    },
    {
        path: "profile",
        canActivate: [RoleGuard],
        data: {
            expectedRole: "Customer"
        },
        loadChildren: () => import("./modules/profile/profile.module").then((m) => m.ProfileModule)
    },
    {
        path: "courses-catalog",
        loadChildren: () =>
            import("./modules/courses-catalog/courses-catalog.module").then((m) => m.CoursesCatalogModule)
    },
    {
        path: "vc",
        loadChildren: () =>
            import("./modules/validates-certificate/validates-certificate.module").then(
                (m) => m.ValidatesCertificateModule
            )
    },
    {
        path: "exam",
        canActivate: [RoleGuard],
        data: {
            expectedRole: "Customer"
        },
        loadChildren: () => import("./modules/exam/exam.module").then((m) => m.ExamModule)
    },
    {
        path: "change-password",
        canActivate: [RoleGuard],
        component: ChangePasswordAfterLoginComponent
    },
    // Fallback when no prior routes is matched
    {
        path: "**",
        redirectTo: "auth",
        pathMatch: "full"
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: "enabled"
        })
    ],
    exports: [RouterModule],
    providers: [USER_COMPLETE_REGISTRATION_PROVIDER]
})
export class AppRoutingModule {}
